import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useCallback } from 'react';
export function useControlled() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _defaultValue = options.defaultValue,
    _options$defaultValue = options.defaultValuePropName,
    defaultValuePropName = _options$defaultValue === void 0 ? 'defaultValue' : _options$defaultValue,
    _options$valuePropNam = options.valuePropName,
    valuePropName = _options$valuePropNam === void 0 ? 'value' : _options$valuePropNam,
    _options$onChangeProp = options.onChangePropName,
    onChangePropName = _options$onChangeProp === void 0 ? 'onChange' : _options$onChangeProp;
  var propValue = props[valuePropName];
  var propOnChange = props[onChangePropName];
  var defaultValue = defaultValuePropName in props ? props[defaultValuePropName] : _defaultValue;
  var isControlled = valuePropName in props;
  var _useState = useState(function () {
      return isControlled ? propValue : defaultValue;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    innerState = _useState2[0],
    setInnerState = _useState2[1];
  var state = isControlled ? propValue : innerState;
  var setState = useCallback(function (state) {
    setInnerState(state);
    if (propOnChange) {
      for (var _len = arguments.length, otherParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        otherParams[_key - 1] = arguments[_key];
      }
      propOnChange.apply(void 0, [state].concat(otherParams));
    }
  }, [propOnChange]);
  return [state, setState];
}